import { createFileRoute } from '@tanstack/react-router'

import { HEAT_PUMP_CHILLER_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { generateRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Génération d'un synoptique PAC / groupe froid. Garde OuiSense et préchargement du catalogue sont
// communs aux catégories de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/heat-pump/technical/generate/')(generateRouteOptions(HEAT_PUMP_CHILLER_DOMAIN))
